import { HomeSVG, RightSVG } from "src/assets/svg";
import { Outlet, useNavigate } from "react-router-dom";
import {
  profileMenuItems,
  profileTeacherMenuItems,
} from "src/static/data/menu_items";
import { useTranslation } from "src/i18n/context";
// import { CheckHemisIdConfig } from "src/service/api";
// import { useEffect } from "react";
// import { notification } from "antd";
import ProfileButton from "src/components/common/button/ProfileButton";

function Profile() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // const [api, contextHolder] = notification.useNotification();

  // const getFunc = () => {
  //   CheckHemisIdConfig().then((res) => {
  //     if (!res.data.status)
  //       api["warning"]({
  //         message: "Diqqat!",
  //         description: res.data.message,
  //         placement: "top",
  //         duration: 120,
  //       });
  //   });
  // };

  // useEffect(() => {
  //   getFunc();
  // }, []);

  return (
    <div className="profile">
      {/* {contextHolder} */}
      <div className="container profile__navbar">
        <h4 className="flex" onClick={() => navigate("/")}>
          <HomeSVG />
          <span>{t("menu.home")}</span>
        </h4>
        <h4>
          <RightSVG />
        </h4>
        <h4 className="flex">
          <span>{t("common.profile")}</span>
        </h4>
      </div>
      <div className="container">
        <div className="profile__sidebar">
          <div className="profile__menu">
            {(
              // Client qismi faqat o'qituvchilar uchun
              [
                {
                  title: t("menu.quizzes"),
                  icon: profileTeacherMenuItems[0]?.icon ?? profileMenuItems[0]?.icon,
                  link: profileTeacherMenuItems[0]?.link ?? profileMenuItems[0]?.link,
                },
                {
                  title: t("menu.personalInfo"),
                  icon: profileTeacherMenuItems[1]?.icon ?? profileMenuItems[1]?.icon,
                  link: profileTeacherMenuItems[1]?.link ?? profileMenuItems[1]?.link,
                },
              ]
            ).map((item) => {
              return (
                <ProfileButton
                  svg={item.icon}
                  title={item.title}
                  link={item.link}
                  key={crypto?.randomUUID()}
                />
              );
            })}
          </div>
        </div>
        <div className="profile__body">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Profile;
